import { makeProgramSchedule, getEmptyProgramSummary } from '../util';
import React from 'react';
import { ICurrentUser } from '../../currentuser/currentUser';
import {
  PLANNING_ENTITY_CAMPAIGN,
  PLANNING_ENTITY_CAMPAIGN_DESCRIPTION,
  PLANNING_ENTITY_PROGRAM,
  PLANNING_ENTITY_SOCIAL_POST,
  PLANNING_ENTITY_SOCIAL_POST_DESCRIPTION,
  PROGRAM_KIND_CAMPAIGN,
  PROGRAM_KIND_PROGRAM,
  ProgramSummary,
} from '../types';
import { Dropdown } from 'react-bootstrap';
import { PlusButton } from './PlusButton';
import { useAddProgramPermissionHelper } from '../programPermissionHelper';
import { CampaignIcon, ChatBalloonIcon, ProgramIcon } from '../../assets/icons';
import { Info } from '../../commons/components/Info';
import { useSocialPostProgramType } from '../hooks/useSocialPostProgramType';
import { useIsFacebookEnabled } from '../../social-posting/hooks/useIsFacebookEnabled';

const DropdownButton = React.forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>(
  ({ onClick }, ref) => (
    <div>
      <div ref={ref} data-test="programs__create-something">
        <PlusButton onClick={onClick} />
      </div>
    </div>
  )
);

export const NewSocialPostButtonContent = () => (
  <>
    <ChatBalloonIcon className="plus-button__menu-item-icon" />
    Social Post
    <Info tooltipText={PLANNING_ENTITY_SOCIAL_POST_DESCRIPTION} tooltipWidth={166} />
  </>
);
export const NewProgramButtonContent = () => (
  <>
    <ProgramIcon className="plus-button__menu-item-icon" />
    Program
  </>
);

export const NewCampaignButtonContent = () => (
  <>
    <CampaignIcon className="plus-button__menu-item-icon" />
    <div className="flex-grow-1">Campaign</div>
    <Info tooltipText={PLANNING_ENTITY_CAMPAIGN_DESCRIPTION} tooltipWidth={166} />
  </>
);
export const AddNewProgram = ({
  onCreate,
  user,
  isScheduledMode,
}: {
  onCreate: (p: ProgramSummary) => void;
  user: ICurrentUser | null;
  isScheduledMode: boolean;
}) => {
  const addProgramPermissionHelper = useAddProgramPermissionHelper();

  let canCreateProgram = addProgramPermissionHelper.canCreateProgram();
  let canCreateCampaign = addProgramPermissionHelper.canCreateCampaign();

  const socialPostProgramType = useSocialPostProgramType();
  const { isFacebookEnabled } = useIsFacebookEnabled();

  return (
    <Dropdown
      onSelect={(eventKey) => {
        const isSocialPosting = eventKey === PLANNING_ENTITY_SOCIAL_POST;
        onCreate(
          getEmptyProgramSummary(
            isSocialPosting ? socialPostProgramType : null,
            makeProgramSchedule({
              type: isScheduledMode ? 'SCHEDULED' : 'UNSCHEDULED',
              wholeDay: true,
              isSocialPosting,
            }),
            user ? user.userId : null,
            eventKey === PLANNING_ENTITY_PROGRAM || isSocialPosting
              ? PROGRAM_KIND_PROGRAM
              : PROGRAM_KIND_CAMPAIGN
          )
        );
      }}
    >
      <Dropdown.Toggle as={DropdownButton} className="d-flex align-items-center" />
      <Dropdown.Menu title="">
        {canCreateProgram && socialPostProgramType && isFacebookEnabled && (
          <Dropdown.Item
            eventKey={PLANNING_ENTITY_SOCIAL_POST}
            data-test="programs__create-social-post"
          >
            <NewSocialPostButtonContent />
          </Dropdown.Item>
        )}
        {canCreateProgram && (
          <Dropdown.Item eventKey={PLANNING_ENTITY_PROGRAM} data-test="programs__create-program">
            <NewProgramButtonContent />
          </Dropdown.Item>
        )}
        {canCreateCampaign && (
          <Dropdown.Item eventKey={PLANNING_ENTITY_CAMPAIGN} data-test="programs__create-campaign">
            <NewCampaignButtonContent />
          </Dropdown.Item>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};
